import React from "react";
import { useApp } from "../context/AppContext";

export default function PortalBackground() {
  const { portal } = useApp();
  const bg = portal?.backgroundImage;
  if (!bg) return null;
  return (
    <div className="fixed inset-0 z-0 pointer-events-none" data-testid="portal-background" aria-hidden="true">
      <img src={bg} alt="" className="w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/85" />
    </div>
  );
}
